import { ThemeEvents } from '@theme/events';

/**
 * <wire-discount-card>
 *
 * Variant değişiminde kendini section'ın re-render edilmiş HTML'inden bulup
 * iç içeriğini günceller. Mevcut <product-price> deseniyle aynı yaklaşım.
 */
class WireDiscountCard extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    if (this.section) {
      this.section.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    }
    this.removeEventListener('click', this.handleClick);
  }

  handleVariantUpdate = (event) => {
    const detail = event.detail ?? {};
    const data = detail.data ?? {};

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const html = data.html;
    if (!html) return;

    const replacement = html.querySelector(`wire-discount-card[data-block-id="${this.dataset.blockId}"]`);
    if (!replacement) {
      this.hidden = true;
      return;
    }

    const newInner = replacement.querySelector('[data-wire-discount-root]');
    const currentInner = this.querySelector('[data-wire-discount-root]');
    if (!newInner || !currentInner) return;

    this.hidden = false;
    currentInner.replaceWith(newInner);

    this.dataset.wireDiscountUpdating = 'true';
    window.setTimeout(() => {
      delete this.dataset.wireDiscountUpdating;
    }, 450);
  };

  handleClick = (event) => {
    const trigger = event.target.closest('[data-wire-discount-trigger]');
    if (!trigger) return;
    event.preventDefault();

    const tooltip = this.querySelector('[data-wire-discount-tooltip]');
    if (!tooltip) return;

    const willOpen = tooltip.hasAttribute('hidden');
    if (willOpen) {
      tooltip.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
    } else {
      tooltip.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }
  };
}

if (!customElements.get('wire-discount-card')) {
  customElements.define('wire-discount-card', WireDiscountCard);
}
